export const scrollToElement = (el, options = {}) => {
  options = {
    ...{
      behavior: 'smooth',
      space: 0,
    },
    ...options,
  };
  window.scrollTo({ top: el.offsetTop + options.space, behavior: options.behavior });
};

export function isElementInViewport(el) {
  var rect = el.getBoundingClientRect();

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) /* or $(window).height() */ &&
    rect.right <=
      (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
  );
}
